var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex justify-center items-center w-10 h-10 border-2 border-primary bg-white rounded-full text-center"},[_c('p',{staticClass:"font-bold text-xs text-primary"},[_vm._v(" "+_vm._s(_vm.getFilterIdentifier())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }